import { render, staticRenderFns } from "./TileDisconnected.vue?vue&type=template&id=4ffb4eb8"
import script from "./TileDisconnected.vue?vue&type=script&lang=js"
export * from "./TileDisconnected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports